<template lang="pug">

  MDashboardWidget( title="AI Inflight Report" )

    div(class="form-group row")

        div(class="col-sm-10")
          label Time Range (days)
          p Download a report of AI interactions for batches with multiple links from the last N days.
          input(type="number" min="1" placeholder="7" class="form-control" v-model.number="days" style="max-width: 200px;")

        div(class="col-sm-12 mt-3")
          button( class="btn btn-details btn-outline btn-info mr-2" v-bind:disabled="loading" v-on:click="generateCSV" )
            i( class="fa fa-spinner fa-spin mr-2" v-if="loading" )
            | Download AI Report

          p( class="text-danger m-0 mt-2" v-if="errorMessage" ) {{ errorMessage }}
          p( class="text-success m-0 mt-2" v-if="successMessage" ) {{ successMessage }}

</template>
<style lang="scss" scoped></style>

<script>
import gql from "graphql-tag";
import Vue from "vue";
export default Vue.extend({
  data() {
    return {
      days: 7,
      loading: false,
      errorMessage: "",
      successMessage: "",
    };
  },
  methods: {
    async generateCSV() {
      this.loading = true;
      this.errorMessage = "";
      this.successMessage = "";

      const days = this.days && this.days > 0 ? this.days : 7;

      try {
        const {
          data: { aiBatchReport },
        } = await this.$apollo.query({
          query: gql`
            query AiBatchReport($days: Int!) {
              aiBatchReport(days: $days) {
                batches {
                  date
                  batchName
                  batchUrl
                  company
                  aiRequests
                  aiErrors
                  percentSuccessful
                }
              }
            }
          `,
          variables: {
            days,
          },
          fetchPolicy: "network-only",
        });

        if (!aiBatchReport || aiBatchReport.batches.length === 0) {
          this.errorMessage = `No batches with multiple links found in the last ${days} day(s).`;
          return;
        }

        // Build CSV
        const header = [
          "Date",
          "Batch Name",
          "Batch URL",
          "Company",
          "AI Requests",
          "AI Errors",
          "% Successful",
        ];

        const dataLines = aiBatchReport.batches.map((b) =>
          [
            new Date(b.date).toISOString().slice(0, 10),
            this.csvEscape(b.batchName),
            this.csvEscape(b.batchUrl),
            this.csvEscape(b.company),
            b.aiRequests,
            b.aiErrors,
            b.percentSuccessful,
          ].join(",")
        );

        const csv = [header.join(","), ...dataLines].join("\r\n");

        // Trigger download
        const filename = `ai-report_${days}d_${new Date().toISOString().slice(0, 10)}.csv`;

        const blob = new Blob([csv], { type: "text/csv;charset=utf-8;" });
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        document.body.appendChild(a);
        a.setAttribute("style", "display:none");
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);

        this.successMessage = `Report downloaded: ${aiBatchReport.batches.length} batch(es) from the last ${days} day(s).`;
      } catch (error) {
        console.error("Error generating AI report:", error);
        this.errorMessage =
          error?.message || "An error occurred while generating the report.";
      } finally {
        this.loading = false;
      }
    },

    csvEscape(value) {
      if (value == null) return "";
      const s = String(value);
      if (/[",\r\n]/.test(s)) {
        return `"${s.replace(/"/g, '""')}"`;
      }
      return s;
    },
  },
});
</script>
